import React from 'react';
import * as styles from '../../style/media-banner';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DomainMediaLogo = () => /* eslint-disable max-len */
___EmotionJSX("div", {
  css: styles.mediaLogo
}, ___EmotionJSX("div", {
  css: styles.innerLogo
}, ___EmotionJSX("svg", {
  viewBox: "0 0 81 18",
  xmlns: "http://www.w3.org/2000/svg"
}, ___EmotionJSX("g", null, ___EmotionJSX("polygon", {
  css: styles.logoSvg,
  points: "18.8,8.9 20,8.1 21.2,8.9 21.2,12.4 22.2,12.4 22.2,8.9 23.4,8.1 24.6,8.9 24.6,12.4 25.6,12.4 25.6,8.4 23.4,7 21.7,8.1 20,7 18.8,7.8 18.8,7.3 17.8,7.3 17.8,12.4 18.8,12.4"
}), ___EmotionJSX("path", {
  css: styles.logoSvg,
  d: "M10.5,11.4c0.6-0.6,1-1.5,1-2.4v0c0-0.9-0.4-1.8-1-2.4C9.9,6,9,5.6,7.9,5.6l-2.4,0v6.8h2.4 C9,12.4,9.9,12.1,10.5,11.4z M6.6,6.6h1.4c0.8,0,1.4,0.2,1.9,0.7c0.4,0.4,0.7,1.1,0.7,1.7v0c0,1.4-1.1,2.4-2.6,2.4H6.6L6.6,6.6z"
}), ___EmotionJSX("circle", {
  css: styles.logoSvg,
  cx: "32.1",
  cy: "5.9",
  r: "0.7"
}), ___EmotionJSX("path", {
  css: styles.logoSvg,
  d: "M34.5,9.5c0-0.8,0.5-1.4,1.3-1.4c0.7,0,1.2,0.5,1.2,1.3v3h1V9.3c0-1.3-0.8-2.1-1.9-2.1c-0.6,0-1.1,0.2-1.5,0.6 V7.3h-1v5.1h1V9.5z"
}), ___EmotionJSX("rect", {
  x: "31.6",
  y: "7.3",
  css: styles.logoSvg,
  width: "1",
  height: "5.1"
}), ___EmotionJSX("path", {
  css: styles.logoSvg,
  d: "M14.6,12.5L14.6,12.5c1.5,0,2.6-1.2,2.6-2.7v0c0-0.7-0.3-1.4-0.7-1.9c-0.5-0.5-1.1-0.8-1.9-0.8 c-0.7,0-1.4,0.3-1.9,0.8C12.3,8.5,12,9.2,12,9.9v0C12,11.4,13.2,12.5,14.6,12.5z M13,9.9c0-1,0.7-1.7,1.6-1.7 c0.9,0,1.6,0.8,1.6,1.7v0c0,0.5-0.2,0.9-0.4,1.2c-0.3,0.3-0.7,0.5-1.1,0.5C13.7,11.6,13,10.8,13,9.9L13,9.9z"
}), ___EmotionJSX("path", {
  css: styles.logoSvg,
  d: "M28.1,12.5c0.7,0,1.2-0.3,1.6-0.6v0.5h1V9.3c0-0.6-0.2-1.2-0.5-1.5c-0.4-0.4-0.9-0.6-1.6-0.6 c-0.6,0-1.2,0.1-1.8,0.4l-0.1,0.1l0.3,0.9l0.1-0.1c0.5-0.2,0.9-0.3,1.4-0.3c0.8,0,1.2,0.4,1.3,1.1c-0.4-0.1-0.8-0.2-1.3-0.2 c-0.6,0-1.2,0.1-1.5,0.4c-0.4,0.3-0.6,0.7-0.6,1.3v0C26.2,12,27.2,12.5,28.1,12.5z M27.2,10.8c0-0.5,0.5-0.8,1.2-0.8 c0.5,0,0.9,0.1,1.2,0.2v0.3c0,0.3-0.1,0.6-0.4,0.8c-0.3,0.2-0.6,0.3-1,0.3C27.8,11.7,27.2,11.4,27.2,10.8L27.2,10.8z"
}), ___EmotionJSX("rect", {
  x: "71.8",
  y: "8.7",
  transform: "matrix(-2.034506e-06 1 -1 -2.034506e-06 89.7573 -71.7571)",
  className: "st1",
  width: "18",
  height: "0.5"
}), ___EmotionJSX("g", null, ___EmotionJSX("path", {
  css: styles.logoSvg,
  d: "M58.8,8.2c-0.7,0-1.2,0.4-1.3,1.1H60C60,8.6,59.5,8.2,58.8,8.2z"
}), ___EmotionJSX("path", {
  css: styles.logoSvg,
  d: "M72.1,10.9c0,0.4,0.4,0.6,0.9,0.6c0.8,0,1.2-0.4,1.2-1.1v-0.3H74C72.1,10.1,72.1,10.7,72.1,10.9z"
}), ___EmotionJSX("path", {
  css: styles.logoSvg,
  d: "M80,0H46.8h-1.1h-2.8H1H0h0v1h0L0,17l0,0v1h1h41.9h2.8h1.1H80h1V0H80z M50.2,7.2c0.8,0,1.3,0.3,1.6,0.9 c0.4-0.6,0.9-0.9,1.7-0.9c0.8,0,1.8,0.4,1.8,2.2l0,3H54l0-2.9c0-0.8-0.3-1.1-0.9-1.1c-0.5,0-1.1,0.3-1.1,1.3l0,2.8h-1.3l0-3 c0-0.8-0.5-1-0.8-1c-0.7,0-1.1,0.5-1.1,1.3v2.8h-1.3V7.3h1.3V8C49,7.5,49.6,7.2,50.2,7.2z M58.8,11.5c0.5,0,1-0.2,1.3-0.7l0,0 l0.9,0.7l0,0c-0.5,0.7-1.3,1-2.2,1c-1.6,0-2.8-1.1-2.8-2.7s1.2-2.7,2.8-2.7c1.5,0,2.4,1.1,2.4,2.8v0.4h-3.8 C57.6,11,58.1,11.5,58.8,11.5z M64.5,12.5c-1.5,0-2.5-1.1-2.5-2.7c0-1.5,1-2.7,2.5-2.7c0.7,0,1.3,0.3,1.7,0.8V4.8h1.3v7.6h-1.3 v-0.7C65.9,12.2,65.3,12.5,64.5,12.5z M69.3,6.4c-0.5,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8c0.5,0,0.8,0.3,0.8,0.8 C70.2,6.1,69.8,6.4,69.3,6.4z M70,12.4h-1.3l0-5.1H70L70,12.4z M74.3,12.4l0-0.7c-0.3,0.5-0.9,0.8-1.6,0.8c-0.5,0-0.9-0.1-1.3-0.4 c-0.4-0.3-0.6-0.7-0.6-1.2c0-1.6,1.7-1.8,3.2-1.8h0.3V9.1c0-0.6-0.4-0.9-1.1-0.9c-0.5,0-1,0.2-1.3,0.5l0,0L71.1,8l0,0 c0.5-0.5,1.3-0.8,2.2-0.8c2.2,0,2.2,1.6,2.2,2.3l0,2.9H74.3z M2,16V2h40v14H2z"
}), ___EmotionJSX("path", {
  css: styles.logoSvg,
  d: "M64.8,8.4c-0.9,0-1.5,0.8-1.5,1.5c0,0.7,0.5,1.5,1.5,1.5c0.9,0,1.5-0.8,1.5-1.5C66.2,9.1,65.7,8.4,64.8,8.4z"
}))))));
/* eslint-enable max-len */

export default DomainMediaLogo;